import { Outlet } from 'react-router-dom'

export default function () {
  return <Outlet />
}
